
import { Component, Prop, Vue, Watch, } from 'vue-property-decorator';
import { DomainMeterDetails, WaterUsageResponse, } from '~/api/self-serve-client';
import Spinner from '~/components/spinner/spinner.vue';
import { pluralise, } from '~/utils/filters/pluralise.filter';
import { toCurrency, } from '~/utils/filters/toCurrency.filter';
import { Completed, Loading, Result, isResult, mapCompleted, } from '~/utils/models/result';
import { MeterDetails, Results, Store, } from '../../store';
import DashboardTile from '../dashboard-tile/dashboard-tile.vue';

@Component({
	components: {
		DashboardTile,
		Spinner,
	},
})
export default class WaterUsageTile extends Vue {
	@Prop({
		type: String,
	})
	contractAccountNumber!: string;

	@Prop({
		type: String,
	})
	contractId!: string;

	@Prop({
		type: Object,
		validator: (obj) => isResult(obj),
	})
	meterDetails!: Results<DomainMeterDetails>;

	@Prop({
		type: Object,
		validator: (obj) => isResult(obj),
	})
	waterUsageDetails!: Result<WaterUsageResponse>;

	reloadTimeout: number | null = null;

	hasResults(obj: Record<string, unknown>) {
		return Object.keys(obj).length;
	}

	get reducedDetails() {
		// if (!isComplete(this.meterDetails)) {
		// 	if (this.meterDetails.state === 'errored') {
		// 		return Loading();
		// 	}
		// 	return this.meterDetails;
		// }
		if (this.meterDetails.state !== 'completed') {
			if (this.meterDetails.state === 'errored') {
				return Loading();
			}
			return this.meterDetails;
		}

		const { result: meterDetails, } = this.meterDetails;
		if (meterDetails.meters.length) {
			return mapCompleted(this.waterUsageDetails, (waterUsageDetails) => {
				return {
					meterDetails: meterDetails.meters,
					waterUsageDetails,
				};
			});
		}

		// return Completed({ meterDetails, });
		return { state: 'completed', result: { meterDetails: meterDetails.meters, }, };
	}

	@Prop({
		type: Object,
		required: false,
		default: { smartMeter: false, smartMeterExchangeState: null, },
	})
	selectedContractAccountSmStatus!: Record<string, string | boolean | null>;

	reloadWaterUsageDetails() {
		if (this.contractAccountNumber && this.contractId && this.meterDetails.state === 'completed' && this.meterDetails.result.meters.length > 0) {
			if (this.reloadTimeout) {
				window.clearTimeout(this.reloadTimeout);
			}

			// Use values as they are at time of request, not execution
			const { contractAccountNumber, contractId, meterDetails: { result, }, } = this;

			this.reloadTimeout = window.setTimeout(() => {
				void Store.dispatch.updateWaterUsageDetails({
					ContractAccountNumber: contractAccountNumber,
					ContractId: contractId,
					MeterCategory: result.meters[0].category as string,
					MeterId: result.meters[0].number as string,
				});
			}, 500);
		}
	}

	@Watch('contractAccountNumber', { immediate: true, })
	onContractAccountNumberChanged(val: string | null) {
		if (val === null || val === this.contractAccountNumber) {
			return;
		}

		this.reloadWaterUsageDetails();
	}

	@Watch('contractId', { immediate: true, })
	onContractIdChanged(val: string | null) {
		if (val === null || val === this.contractId) {
			return;
		}

		this.reloadWaterUsageDetails();
	}

	@Watch('meterDetails', { immediate: true, })
	onMeterDetailsChanged(val: MeterDetails | null) {
		if (val === null) {
			return;
		}

		this.reloadWaterUsageDetails();
	}

	pluralise = pluralise;
	toCurrency = toCurrency;
}
